/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ICurvePoolPeggedAssetsLike,
  ICurvePoolPeggedAssetsLikeInterface,
} from "../ICurvePoolPeggedAssetsLike";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256[2]",
        name: "_amounts",
        type: "uint256[2]",
      },
      {
        internalType: "uint256",
        name: "_min_mint_amount",
        type: "uint256",
      },
    ],
    name: "add_liquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_lpTokenAmount",
        type: "uint256",
      },
      {
        internalType: "int128",
        name: "_coinIndex",
        type: "int128",
      },
    ],
    name: "calc_withdraw_one_coin",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int128",
        name: "_i",
        type: "int128",
      },
      {
        internalType: "int128",
        name: "_j",
        type: "int128",
      },
      {
        internalType: "uint256",
        name: "_dx",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_min_dy",
        type: "uint256",
      },
    ],
    name: "exchange",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "get_virtual_price",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ICurvePoolPeggedAssetsLike__factory {
  static readonly abi = _abi;
  static createInterface(): ICurvePoolPeggedAssetsLikeInterface {
    return new utils.Interface(_abi) as ICurvePoolPeggedAssetsLikeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ICurvePoolPeggedAssetsLike {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ICurvePoolPeggedAssetsLike;
  }
}
